export const BaseMarketingSectionSkeleton = () => {
	return (
		<div className={`py-8 odd:bg-white even:bg-gray-50`}>
			<div className="mx-auto flex max-w-screen-2xl flex-row items-baseline justify-between p-4">
				<h1 className="animate-pulse text-2xl font-semibold text-gray-300"></h1>
			</div>
			<div className="mx-auto grid max-w-screen-2xl grid-cols-3 gap-4 p-4 md:gap-10 lg:grid-cols-5 xl:grid-cols-7">
				{[...Array(4)].map((_, index) => (
					<div
						key={`marketing_section_skeleton_${index}`}
						className="relative h-32 w-full animate-pulse rounded-lg border bg-gray-200"
					></div>
				))}
			</div>
		</div>
	);
};
